interface UserIconProps {
    className?: string;
}

export const UserIcon = ({ className }: UserIconProps = {}) => (
    <img className={className || 'w-full h-full'} src={`${window.location.origin}/icons/28px_AccountSettings.svg`} alt="User" />
);
